
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  userDetails: {},
  userData:{},
  loginTimestamp: null, // Track the login timestamp
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.userDetails = action.payload.data; // Save user details in state
      state.userData = action.payload.data;
      state.loginTimestamp = new Date().getTime(); // Store the current time when the user logs in

      // Persist the state in localStorage
      localStorage.setItem('authState', JSON.stringify(state));
      localStorage.setItem('userState', JSON.stringify(state.userDetails));

    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.userDetails = {}; // Clear user details
      state.loginTimestamp = null; // Clear login timestamp

      // Clear persisted state in localStorage
      localStorage.removeItem('authState');
      localStorage.removeItem('userState');

    },
    loadUserFromStorage: (state) => {
      const savedState = localStorage.getItem('authState');
      const userSatedSaved = localStorage.getItem('userState');


      if (savedState) {
        const parsedState = JSON.parse(savedState);

       
          state.isAuthenticated = true;
          state.userDetails = parsedState.userDetails;
          // state.userData = parsedState.userData;
          state.loginTimestamp = parsedState.loginTimestamp;

          if(userSatedSaved){
            state.userData = JSON.parse(userSatedSaved);
          }
       
      } else {
        state.isAuthenticated = false;
        state.userDetails = {};
        state.userData = {};
        state.loginTimestamp = null;
      }
    },
  },
});

export const { login, logout, loadUserFromStorage } = authSlice.actions;
export default authSlice.reducer;
